import React from 'react'

function Rep_IPDReports() {
  return (
    <div>IPD Reports</div>
  )
}

export default Rep_IPDReports